import axios from 'axios';
import { API_BASE } from '../config';

const client = axios.create({ baseURL: API_BASE, timeout: 15000 });

export async function fetchJobs({ q = '', country = '', profession = '', page = 1 } = {}) {
  const { data } = await client.get('/public/jobs', { params: { q, country, profession, page } });
  return data; // { jobs, page, pageSize, total, totalPages }
}

export async function fetchJob(slug) {
  const { data } = await client.get(`/public/jobs/${encodeURIComponent(slug)}`);
  return data.job;
}
